"use client";

import AboutHero from "@/components/about/AboutHero";
import AboutPresentation from "@/components/about/AboutPresentation";
//import AboutTeam from "@/components/about/AboutTeam";
import AboutContact from "@/components/about/AboutContact";

const AboutPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <AboutHero />
      <AboutPresentation />
      {/* <AboutTeam /> */}
      <AboutContact />
    </div>
  );
};

export default AboutPage;
